module.exports = __webpack_public_path__ + "static/media/thunder.fc4ec453.svg";